import React from "react";
import { Link } from "react-router-dom";
import { handlePlayerReady, playpause, hideplayIcon } from "../../utils/Helper";
import VideoPlayer from "../../common/VideoPlayer";

const AllEpisodeBanner = ({
  episodeData,
  episodeListData,
  episodeId,
  setEpisodeId,
}) => {
  const episodeTitle = episodeData?.title || "";
  // const nextEpisodeTitle = episodeListData?.[episodeId]?.title || "";

  // console.log(episodeListData);

  const getNextEpisode = (sequence) => {
    if (sequence <= 7) {
      const next = parseInt(sequence) + 1;
      if (next < 8) {
        let final = episodeListData.filter((val) => val.sequence == next);

        return final;
      } else if (sequence == 7) {
        let final = episodeListData.filter((val) => val.sequence == 7);
        return final;
      } else {
        return null;
      }
    }
  };
  // console.log(episodeData.sequence);

  return (
    <>
      <section className="episode_banner_section">
        <div className="container-fluid">
          <div className="episode_banner_pad">
            {episodeId < 8 && (
              <ul className="episode_breadcrumb">
                <li>
                  <h4>Episode {episodeData.sequence}</h4>
                </li>
                <li>
                  <Link to={`/shortreels?episode_id=${episodeId}`}>
                    View Short Reels
                    <img src="/assets/images/arrow_shape.svg" alt="" />
                  </Link>
                </li>
              </ul>
            )}

            <div className="videoppc_mainflex">
              <div className="body_edition">
                <h3>{episodeTitle}</h3>
              </div>
              {episodeId < 8 && (
                <div className="nextepi_order">
                  {episodeData.sequence < 7 && (
                    <button
                      className="nextepic_btn"
                      onClick={() => {
                        let id = getNextEpisode(episodeData.sequence)[0].id;
                        if (id) {
                          setEpisodeId(id);
                        }
                      }}
                      // onClick={() => setEpisodeId((prev) => parseInt(prev) + 1)}
                      disabled={episodeData.sequence > 6}
                    >
                      <img src="/assets/images/nextepisodeplay.svg" alt="" />{" "}
                      Next Episode
                    </button>
                  )}
                  {episodeData.sequence < 7 && (
                    <h6>{getNextEpisode(episodeData.sequence)[0].title}</h6>
                  )}
                </div>
              )}
              {episodeData && episodeData.video_url && (
                <div className="main_video_play">
                  {/* <img
                  src="/assets/images/img-21.jpg"
                  className="sundervideo_banner"
                  alt=""
                /> */}
                  <div className="video_tab video_tab_episode">
                    {episodeData && episodeData.video_url && (
                      <VideoPlayer
                        onReady={handlePlayerReady}
                        id={episodeData.id}
                        keyi={episodeData.id}
                        key={episodeData.id}
                        video_url={episodeData.video_url}
                        thumb={episodeData.image_url}
                        type="long"
                      />
                    )}
                    <span
                      className="play_layer"
                      onClick={() => {
                        playpause(episodeData.id, "long");
                      }}
                      onMouseMove={() => {
                        hideplayIcon(episodeData.id, "long");
                      }}
                    >
                      <img
                        src="/assets/images/play2.svg"
                        className={"play_icon playpausebtn_" + episodeData.id}
                        alt=""
                      />
                    </span>
                    <span
                      className="main_play"
                      onClick={() => {
                        playpause(episodeData.id, "long");
                      }}
                    ></span>
                  </div>
                  {/* <div className="sunder_video_overlay"></div>
                <button className="sunderplay_btn">
                  <img src="/assets/images/playvideoppc.svg" alt="" />
                </button> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllEpisodeBanner;
